import { ErrorHandler, NgModule } from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import { ImageComponent } from './components/image/image.component';
import { CustomTableComponent } from './components/custom-table/custom-table.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { CommonModule } from '@angular/common';
import { DragDropDirective } from './directives/drag-drop.directive';
import { StepperComponent } from './components/stepper/stepper.component';
import { HeaderComponent } from './components/header/header.component';
import { MatTableModule } from '@angular/material/table';
import { GridTableOneComponent } from './components/grid-table-one/grid-table-one.component';
import { CreditorClaimantModalComponent } from './components/creditor-claimant-modal/creditor-claimant-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RegistrationFormPrintComponent } from './components/account-request-and-pod-submission/preview-and-declare/registration-form-print/registration-form-print.component';
import { ConfirmPopupComponent } from './components/confirm-popup/confirm-popup.component';
import { OkPopupComponent } from './components/ok-popup/ok-popup.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { DialogComponent } from './components/dialog/dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NotificationTimeoutComponent } from './components/notification-timeout/notification-timeout.component';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { ToolTipComponent } from './components/tooltip/tooltip.component';
import { TooltipDataComponent } from './components/tooltip-data/tooltip-data.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DetailsClaimantComponent } from './components/account-request-and-pod-submission/details-claimant/details-claimant.component';
import { MatInputModule } from '@angular/material/input';
import { ParticularsOfDebtComponent } from './components/account-request-and-pod-submission/particulars-dept/particulars-dept.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { MatSelectModule } from '@angular/material/select';
import { SecuritiesHeldComponent } from './components/account-request-and-pod-submission/securities-held/securities-held.component';
import { ParticularsOfInterestComponent } from './components/account-request-and-pod-submission/particulars-interest/particulars-interest.component';
import { CustomPaginatorComponent } from './components/custom-paginator/custom-paginator.component';
import { BaseTableComponent } from './components/base-table/base-table.component';
import { DetailsAuthorComponent } from './components/account-request-and-pod-submission/details-author/details-author.component';
import { CreditorInfoComponent } from './components/account-request-and-pod-submission/creditor-info/creditor-info.component';
import { PreviewAndDeclareComponent } from './components/account-request-and-pod-submission/preview-and-declare/preview-and-declare.component';
import { UploadService } from './services/upload.service';
import { HeaderService } from './components/header/header.service';
import { UserAccountPopupComponent } from './components/useraccount-popup/useraccount-popup.component';
import { UserAccountDropdownPopupComponent } from './components/useraccount-dropdown-popup/useraccount-dropdown-popup.component';
import { WithdrawalPopupComponent } from './components/withdrawal-popup/withdrawal-popup.component';
import { DeclarationPopupComponent } from './components/declaration-popup/declaration-popup.component';
import { NotifierModule } from 'angular-notifier';
import { NotifierDefaultOptions } from './components/notifier-message/notifier-default-options';
import { DebounceClickDirective } from './directives/debounce-click.directive';
import { NgxMaskModule } from 'ngx-mask';
import { CookieComponent } from './components/cookie/cookie.component';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';
import { MatTabsModule } from '@angular/material/tabs';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AmountInputComponent } from './components/amount-input/amount-input.component';
import { SupportingDocumentClaimsComponent } from './components/supporting-document-claims/supporting-document-claims.component';
import { MatSortModule } from '@angular/material/sort';
import { SupportingDocumentsClaimDetailComponent } from './components/supporting-documents-claim-detail/supporting-documents-claim-detail.component';
import { SupportingDocumentService } from './services/supportingDocument.service';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';



@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatInputModule,
        MatTableModule,
        MatDialogModule,
        MatTooltipModule,
        TooltipModule,
        MatCheckboxModule,
        MatSidenavModule,
        MatMenuModule,
        MatSlideToggleModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        NotifierModule.withConfig(NotifierDefaultOptions),
        NgxMaskModule.forRoot(),
        MatTabsModule,
        PdfViewerModule,
        MatSortModule,
        CKEditorModule
    ],
    declarations: [
        ImageComponent,
        CustomTableComponent,
        SearchInputComponent,
        UploadFileComponent,
        HeaderComponent,
        StepperComponent,
        DragDropDirective,
        BaseTableComponent,
        GridTableOneComponent,
        CreditorClaimantModalComponent,
        TermsConditionsComponent,
        RegistrationFormPrintComponent,
        ConfirmPopupComponent,
        OkPopupComponent,
        DialogComponent,
        ToolTipComponent,
        TooltipDataComponent,
        DetailsClaimantComponent,
        ParticularsOfDebtComponent,
        ParticularsOfInterestComponent,
        SecuritiesHeldComponent,
        CustomPaginatorComponent,
        DetailsAuthorComponent,
        CreditorInfoComponent,
        PreviewAndDeclareComponent,
        NotificationTimeoutComponent,
        UserAccountPopupComponent,
        UserAccountDropdownPopupComponent,
        WithdrawalPopupComponent,
        DeclarationPopupComponent,
        DebounceClickDirective,
        CookieComponent,
        CookiePolicyComponent,
        AmountInputComponent,
        SupportingDocumentClaimsComponent,
        SupportingDocumentsClaimDetailComponent
    ],
    exports: [
        MatInputModule,
        MatIconModule,
        ImageComponent,
        CustomTableComponent,
        SearchInputComponent,
        UploadFileComponent,
        HeaderComponent,
        StepperComponent,
        DragDropDirective,
        BaseTableComponent,
        GridTableOneComponent,
        CreditorClaimantModalComponent,
        MatTooltipModule,
        MatCheckboxModule,
        TermsConditionsComponent,
        RegistrationFormPrintComponent,
        ConfirmPopupComponent,
        OkPopupComponent,
        MatSidenavModule,
        DialogComponent,
        MatSlideToggleModule,
        ToolTipComponent,
        TooltipDataComponent,
        TooltipModule,
        MatFormFieldModule,
        FormsModule,
        MatSelectModule,
        MatAutocompleteModule,
        DetailsClaimantComponent,
        ParticularsOfDebtComponent,
        ParticularsOfInterestComponent,
        SecuritiesHeldComponent,
        CustomPaginatorComponent,
        DetailsAuthorComponent,
        CreditorInfoComponent,
        PreviewAndDeclareComponent,
        NotificationTimeoutComponent,
        UserAccountPopupComponent,
        UserAccountDropdownPopupComponent,
        NotifierModule,
        DebounceClickDirective,
        CookieComponent,
        CookiePolicyComponent,
        AmountInputComponent
    ],
    providers: [UploadService, HeaderService,SupportingDocumentService]
})
export class SharedModule {}
